module.exports = __webpack_public_path__ + "static/media/inf_15pog16p.c4750127.mp3";